module.exports = __webpack_public_path__ + "bbd62bf6a0a6bcf2dfdab30a42a8712b.jpg";